import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";

import {Form} from "react-bootstrap";
import {File} from "@gravity-ui/icons";
import {Button} from "@gravity-ui/uikit";

import {
    getAcceptAuthConfig, getJSONAcceptAuthConfig,
    PROJECT_DISTRIBUTION_MANAGER_DETAIL_ENDPOINT, WORKSHOPS_INFO_ENDPOINT
} from "../../../api/api";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {LinkLikeButton_File} from "../../../components/Button/Button";

function ProjectManagerSelectionForm() {
    const {id} = useParams();
    const [activeWorkshop, setActiveWorkshop] = useState(null);


    const [isLoading, setIsLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const [selectionData, setSelectionData] = useState();
    const [selectionDataToSend, setSelectionDataToSend] = useState({
        id: "",
        grade: 0,
        comment: "",
    });

    useEffect(() => {
        Promise.all([
                axios
                .get(WORKSHOPS_INFO_ENDPOINT, {
                    params: {is_active: "True"},
                    headers: getJSONAcceptAuthConfig().headers,
                })
                .then(response => {
                    setActiveWorkshop((response.data[0]))
                })
                .catch(error => {
                    console.error('Error getting active workshop data:', error);
                }),
                axios
                .get(PROJECT_DISTRIBUTION_MANAGER_DETAIL_ENDPOINT(id), getAcceptAuthConfig())
                .then(response => {
                    const {id, grade, comment} = response.data.projects_user;
                    setSelectionData(response.data);
                    setSelectionDataToSend({id, grade, comment});
                })
                .catch(error => {
                    console.error('Error getting selection Data:', error);
                })
        ])
        .finally(() => {
            setIsLoading(false);
        });
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);

        if (!selectionDataToSend.comment) {
            selectionDataToSend.comment = "";
        }

        axios
            .put(PROJECT_DISTRIBUTION_MANAGER_DETAIL_ENDPOINT(id), selectionDataToSend, getAcceptAuthConfig())
            .then(response => {
                navigate('../', {relative: "path"});
            })
            .catch(error => {
                console.error('Error submitting form:', error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    }

    const onChange = (e) => {
        const {name, value, type} = e.target;
        if (type === 'number') {
            const numericValue = value ? parseInt(value, 10) : "";
            setSelectionDataToSend(prevData => ({
                ...prevData,
                [name]: numericValue,
            }));
        } else {
            setSelectionDataToSend(prevData => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    return (
        <>
            <h3 className="mb-2">Заявка</h3>
            <hr className="clearfix w-100 pb-0"/>
            {isLoading &&
                <LoadingSpinner/> ||
                <>
                    <div className={"bmm-text_bold selection-cv"}>
                        <p>{selectionData.projects_user.user.name}</p>

                        <strong>Образование</strong><br/>
                        <p className={"selection-text"}>{selectionData.cv.education || "–"}</p>

                        <strong>Опыт работы</strong>
                        <p className={"selection-text"}>{selectionData.cv.experience || "–"}</p>

                        <strong>Достижения</strong>
                        <p className={"selection-text"}>{selectionData.cv.achievements || "–"} <br/>

                            {selectionData.cv.achievements_confirmation_file &&
                                <LinkLikeButton_File href={selectionData.cv.achievements_confirmation_file}
                                                     icon={<File/>}
                                                     text={'Документы, подтверждающие достижения'}
                                                     fileName={selectionData.projects_user.user.name + ' Достижения'}
                                />
                                // <a href={selectionData.cv.achievements_confirmation_file} target="_blank">
                                //     <File/> Документы, подтверждающие достижения
                                // </a>
                            }
                        </p>

                        <strong>Навыки</strong>
                        <p className={"selection-text"}>{selectionData.cv.skills || "–"}</p>

                        <strong>Интересы в научной сфере</strong>
                        <p className={"selection-text"}>{selectionData.cv.scientific_interests || "–"}</p>

                        <strong>Ожидания от мастерской</strong>
                        <p className={"selection-text"}>{selectionData.cv.expectations || "–"}</p>

                        <strong>Прочие комментарии</strong>
                        <p className={"selection-text"}>{selectionData.cv.other_comments || "–"}</p>

                        <p>
                            {selectionData.projects_user.file &&
                                <LinkLikeButton_File href={selectionData.projects_user.file}
                                                     icon={<File/>}
                                                     text={'Решение тестового задания'}
                                                     fileName={selectionData.projects_user.user.name + ' Тестовое'}
                                />
                                // <a href={selectionData.projects_user.file} target="_blank">
                                //     <File/> Решение тестового задания
                                // </a>
                            }
                        </p>

                    </div>

                        <Form onSubmit={onSubmit}>
                            <Form.Group controlId="grade">
                                <Form.Label className={"required"}>Оценка (от 0 до 100)</Form.Label>
                                <Form.Control required name="grade"
                                              type="number"
                                              min="0" max="100"
                                              onChange={onChange}
                                              value={selectionDataToSend.grade}
                                />
                                <Form.Text id="zeroGradeHelpBlock" muted>
                                    Внимание! Оценка в 0 баллов приравнивается к отказу от этого участника.
                                    В таком случае участник не будет распределён в данный проект, даже если он больше никуда не пройдёт и при этом в данном проекте ещё будут свободные места.
                                </Form.Text>
                            </Form.Group>

                            <Form.Group controlId="comment">
                                <Form.Label>Комментарий (не более 300 символов)</Form.Label>
                                <Form.Control name="comment" as="textarea" rows={3} maxLength={300}
                                              onChange={onChange}
                                              value={selectionDataToSend.comment || ""}
                                />
                                <Form.Text id="managerCommentHelpBlock" muted>
                                    Это поле видят только кураторы данного проекта
                                </Form.Text>
                            </Form.Group>

                            <Button view="action" type="submit" disabled={!activeWorkshop?.managers_can_evaluate || submitting} size="xl" width="max">
                                {activeWorkshop?.managers_can_evaluate ? (submitting ? "Сохранение..." : "Сохранить") : "В данный момент изменение баллов и комментариев запрещено."}
                            </Button>
                        </Form>

                </>
            }
        </>
    );
}

export default ProjectManagerSelectionForm;